export const CHECKOUT_URL = 'https://ebookpoint.shop/cart/50738447909116:1'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/kcsJ1rJjuPMUkR6jsYQXV1/ChatGPT_Image_28_jun_2026__03_48_37_p.m.-removebg-preview.png'

export type Module = {
  title: string
  items: string[]
}

export const modules: Module[] = [
  {
    title: '🦴 TOMO 1 — Fundamentos de la postura',
    items: [
      'Anatomía postural y cadenas musculares.',
      'Cadenas anterior, posterior y cruzadas.',
      'Ejes y planos corporales.',
      'Evaluación postural.',
      'Test visual.',
      'Fotografías comparativas.',
      'Plomada.',
      'Apps de análisis postural.',
    ],
  },
  {
    title: '🩺 TOMO 2 — Desalineaciones y patologías más comunes',
    items: [
      'Hipercifosis.',
      'Hiperlordosis.',
      'Escoliosis.',
      'Anteproyección cervical.',
      'Báscula pélvica.',
      'Pie plano y pie cavo.',
      'Genu valgo y genu varo.',
      'Principales causas.',
      'Abordaje desde el ejercicio.',
    ],
  },
  {
    title: '👨‍👩‍👧‍👦 TOMO 3 — Gimnasia postural según población',
    items: [
      'Niños y adolescentes.',
      'Oficinistas y sedentarios.',
      'Adultos mayores.',
      'Embarazadas.',
      'Deportistas.',
      'Adaptaciones según cada perfil.',
    ],
  },
  {
    title: '🧘 TOMO 4 — Rutinas y ejercicios correctivos por zona',
    items: [
      'Cervical.',
      'Dorsal y escápulas.',
      'Lumbar.',
      'Cadera.',
      'Miembros inferiores.',
      'Progresiones.',
      'Uso de materiales.',
      'Clases individuales y grupales.',
    ],
  },
  {
    title: '🌬️ TOMO 5 — Reeducación postural y técnicas complementarias',
    items: [
      'Introducción al RPG.',
      'Conceptos de Mézières.',
      'Pilates postural.',
      'Respiración.',
      'Conciencia corporal.',
    ],
  },
  {
    title: '📈 TOMO 6 — Programación, seguimiento y negocio',
    items: [
      'Clases grupales e individuales.',
      'Evaluación inicial.',
      'Reevaluación a 30, 60 y 90 días.',
      'Antes y después.',
      'Paquetes y servicios.',
      'Fidelización.',
      'Trabajo interdisciplinario.',
    ],
  },
]

export type Bonus = {
  title: string
  items: string[]
  image?: string
}

export const bonuses: Bonus[] = [
  {
    title: '🗂️ BONO 1 — Fichas de evaluación postural imprimibles',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/876b9ec9-990b-46fa-81fe-4d233a7bccbb.jpg',
    items: [
      'Evaluación inicial.',
      'Reevaluación a 30 días.',
      'Reevaluación a 60 días.',
      'Reevaluación a 90 días.',
      'Registro de evolución.',
      'Observaciones del profesional.',
    ],
  },
  {
    title: '📚 BONO 2 — Biblioteca de ejercicios correctivos',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/90e0795a-8e74-4368-9aea-e73f5ac23c8f.jpg',
    items: [
      'Ejercicios para cervical.',
      'Ejercicios para dorsal.',
      'Ejercicios para lumbar.',
      'Ejercicios para cadera.',
      'Ejercicios para miembros inferiores.',
      'Objetivos de cada ejercicio.',
      'Progresiones.',
      'Errores frecuentes.',
      'Indicaciones prácticas.',
    ],
  },
  {
    title: '📋 BONO 3 — Programas listos para aplicar',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c5023a8a-d1d1-4652-9fa3-2716168bc013.jpg',
    items: [
      'Programa para oficinistas.',
      'Programa para adultos mayores.',
      'Programa para embarazadas.',
      'Programa para deportistas.',
      'Planificaciones listas para implementar.',
    ],
  },
  {
    title: '👥 BONO 4 — Pack de clases grupales listas',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/23f6043d-d0c0-4b46-a21e-9a8df9734917.jpg',
    items: [
      'Clases completas listas para aplicar.',
      'Objetivos de cada clase.',
      'Ejercicios organizados.',
      'Adaptaciones según nivel.',
      'Progresiones.',
    ],
  },
  {
    title: '📝 BONO 5 — Cuestionario de detección rápida',
    items: [
      'Dolor cervical.',
      'Dolor lumbar.',
      'Sedentarismo.',
      'Hábitos laborales.',
      'Actividad física.',
      'Factores de riesgo postural.',
      'Identificación de necesidades del alumno.',
    ],
  },
]

export const problems: string[] = [
  'Llegas a la clase con la idea armada en la cabeza y terminas improvisando ejercicios sobre la marcha.',
  'En el mismo grupo tienes una hipercifosis, una escoliosis y un dolor lumbar, y no sabes cómo adaptar la sesión para todos.',
  'Evalúas la postura “a ojo”, sin fichas ni registro, y después no puedes demostrar la evolución del alumno.',
  'Repites siempre los mismos ejercicios porque no tienes progresiones claras, y los alumnos se aburren y abandonan.',
  'Pierdes horas cada semana preparando clases desde cero en lugar de sumar alumnos y cobrar mejor tus servicios.',
]

export const benefits = [
  {
    icon: 'clock',
    title: 'Recuperas tus horas',
    text: 'Planificaciones y clases ya estructuradas: abres el PDF, eliges el perfil del alumno y das la clase.',
  },
  {
    icon: 'shield',
    title: 'Clases seguras y con criterio',
    text: 'Sabes qué trabajar y qué evitar en cada desalineación, con progresiones y adaptaciones claras.',
  },
  {
    icon: 'chart',
    title: 'Resultados que se pueden mostrar',
    text: 'Fichas de evaluación y reevaluación a 30, 60 y 90 días para demostrar el antes y después.',
  },
  {
    icon: 'wallet',
    title: 'Más profesional, mejor pagado',
    text: 'Paquetes, seguimiento y fidelización para vender servicios de valor, no clases sueltas.',
  },
]

export const gmailReviews = [
  {
    sender: 'Marta Ruiz',
    email: 'marta.ruiz88@gmail.com',
    subject: 'Gracias, por fin ordené mis clases',
    time: '09:14',
    body: 'Llevaba dos años improvisando. Con las fichas y los programas por perfil ya tengo todas mis sesiones planificadas para el mes. Un cambio brutal.',
    initial: 'M',
    color: 'bg-emerald-600',
  },
  {
    sender: 'Javier Alonso',
    email: 'jalonso.fisio@gmail.com',
    subject: 'Los bonos valen el material entero',
    time: '18:42',
    body: 'La biblioteca de ejercicios correctivos por zona la uso todos los días. Mis grupos mixtos ahora tienen adaptación para cada caso.',
    initial: 'J',
    color: 'bg-teal-700',
  },
  {
    sender: 'Nuria Sanchís',
    email: 'nuriasanchis@gmail.com',
    subject: 'Mis alumnas ven la evolución',
    time: '12:05',
    body: 'La reevaluación a 30 y 60 días me sirvió para renovar 9 de 11 alumnas. Ven en papel su progreso y siguen.',
    initial: 'N',
    color: 'bg-lime-700',
  },
  {
    sender: 'Óscar Pardo',
    email: 'oscarpardo.training@gmail.com',
    subject: 'Descargado y aplicado el mismo día',
    time: '21:30',
    body: 'Entrega inmediata, todo en PDF y listo para imprimir. El pack de clases grupales me ahorró el finde entero de preparación.',
    initial: 'Ó',
    color: 'bg-stone-600',
  },
]

export const testimonials = [
  {
    name: 'Cristina Molina',
    role: 'Profesora de gimnasia postural · 41 años · Valencia',
    text: 'Antes preparaba cada clase de cero. Ahora sigo los tomos por zona y tengo la sesión lista en diez minutos.',
  },
  {
    name: 'Rubén Castaño',
    role: 'Técnico deportivo · 35 años · Bilbao',
    text: 'Lo que más me sirvió fue el tomo de desalineaciones: sé qué evitar en hiperlordosis y escoliosis sin dudar.',
  },
  {
    name: 'Lucía Ferrer',
    role: 'Instructora de pilates postural · 29 años · Sevilla',
    text: 'Los programas para oficinistas y embarazadas los apliqué tal cual. Mis grupos crecieron de 6 a 14 personas.',
  },
  {
    name: 'Ana Belén Quirós',
    role: 'Monitora de mayores · 52 años · Oviedo',
    text: 'Trabajo con adultos mayores y necesitaba progresiones suaves y seguras. Aquí están todas, ordenadas.',
  },
  {
    name: 'Sergio Íñiguez',
    role: 'Preparador físico · 38 años · Zaragoza',
    text: 'Las fichas de evaluación me hicieron parecer mucho más profesional. Ahora cobro paquetes de 90 días.',
  },
]

export const objections = [
  {
    q: '¿Sirve si recién empiezo con la gimnasia postural?',
    a: 'Sí. El Tomo 1 arranca desde anatomía postural y cadenas musculares, con lenguaje claro. Si ya tienes experiencia, puedes ir directo a las rutinas y programas.',
  },
  {
    q: 'No tengo tiempo para estudiar 6 tomos.',
    a: 'No hace falta. Está pensado como material de consulta: buscas la zona o el perfil del alumno y aplicas la clase que ya está armada.',
  },
  {
    q: '¿Es un curso con vídeos o son PDFs?',
    a: 'Es 100% PDF, para leer en el móvil, la tablet o imprimir las fichas y llevarlas a la sala.',
  },
  {
    q: '¿Cómo lo recibo?',
    a: 'Entrega inmediata tras el pago: recibes el acceso de descarga en tu correo en cuestión de minutos.',
  },
  {
    q: '¿Es un pago único o una suscripción?',
    a: 'Pago único. Sin cuotas, sin renovaciones. Lo descargas y es tuyo para siempre, bonos incluidos.',
  },
  {
    q: '¿Y si no me sirve?',
    a: 'Escríbenos a EbookDreamShop@gmail.com y te ayudamos con lo que necesites. Damos soporte real por correo.',
  },
]

export const popupNames = [
  'María', 'Javier', 'Laura', 'Carlos', 'Nuria', 'Alberto', 'Cristina',
  'Rubén', 'Lucía', 'Sergio', 'Patricia', 'Iván', 'Marta', 'Andrés', 'Elena',
]

export const popupCities = [
  'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Bilbao', 'Málaga',
  'Murcia', 'Granada', 'Alicante', 'Valladolid', 'Vigo', 'Oviedo', 'Salamanca',
  'Santander', 'Pamplona', 'A Coruña', 'Palma de Mallorca',
]
